import {createApp} from 'vue';

import axios from 'axios';

const lodash = require('lodash');
const queryString = require('query-string');

import searchBarMixin from './searchBarMixin';

createApp({
    data() {
        return {
            queryString,
            loading: false,
            apiError: false,
            allListingsShown: false,
            totalListings: 0,
            sortOptions: [],
            sort: 'newtoold',
            starRatings: {
                2: '2+',
                3: '3+',
                4: '4+',
                5: '5',
            },
            stars: '',
            maxStarRatingAmongListings: 5,
        }
    },
    mixins: [searchBarMixin],
    components: {},
    props: [],
    computed: {
        resultsHTML() {
            let string = '';
            for (let i = 0; i < this.results.length; i++) {
                string += lodash.unescape(this.results[i]);
            }
            return string;
        },
        starRatingsLabel() {
            if (this.starRatings[this.stars] !== undefined) {
                return this.starRatings[this.stars];
            }
            return '';
        },
    },
    watch: {
        async destination() {
            await this.doSearch();
        },
        async type() {
            await this.doSearch();
        },
        async stars() {
            await this.doSearch();
        },
        async sort() {
            await this.doSearch();
        },
    },
    methods: {
        async resetResults() {
            this.destination = '';
            this.type = '';
            this.stars = '';
            this.maxStarRatingAmongListings = 5;
            this.page = 0;
            this.totalListings = 0;
            this.results = [];
            await this.getResults();
        },
        async doSearch() {
            this.page = 0;
            this.totalListings = 0;
            this.results = [];
            this.addFilterValuesToURL();
            await this.getResults();
        },
        async getSortOptions() {

            let url = '/api/sortoptions';

            try {
                await axios.get(
                    url,
                    {
                        headers: {
                            'content-type': 'application/x-www-form-urlencoded'
                        }
                    }
                ).then((response) => {
                    let data = response.data;
                    this.sortOptions = data.SortOptions;
                    this.sort = data.DefaultSortOption;
                });
            } catch (err) {
                this.sortOptions = [];
                this.sort = '';
            }
        },
        addFilterValuesToURL() {
            let pageURL = new URL(window.location.href);
            let pageBaseURL = pageURL.origin + pageURL.pathname;
            const nextURL = new URL(pageBaseURL);

            for (const [key, value] of Object.entries(this.searchData)) {
                nextURL.searchParams.append(key, value);
            }

            const pageTitle = document.getElementsByTagName("title")[0].innerHTML;
            window.history.replaceState({}, pageTitle, nextURL.href);
        },
        setFilterValuesFromURL() {
            let pageURL = new URL(window.location.href);

            if (this.notUndefinedNullOrBlankString(pageURL.searchParams.get('destination'))) {
                this.destination = pageURL.searchParams.get('destination');
            }

            if (this.notUndefinedNullOrBlankString(pageURL.searchParams.get('type'))) {
                this.type = pageURL.searchParams.get('type');
            }

            if (this.notUndefinedNullOrBlankString(pageURL.searchParams.get('stars'))) {
                this.stars = pageURL.searchParams.get('stars');
            }

            if (this.notUndefinedNullOrBlankString(pageURL.searchParams.get('sort'))) {
                this.sort = pageURL.searchParams.get('sort');
            }
        },
        async handleScroll() {
            if (this.allListingsShown === false) {
                let resultsScroll = this.$refs.resultsScroll;
                if (resultsScroll.getBoundingClientRect().bottom < window.innerHeight) {
                    await this.getResults();
                }
            }
        },
    },
    async mounted() {
        await this.getSortOptions();
        this.setFilterValuesFromURL();
        await this.getResults();
        window.addEventListener("scroll", this.handleScroll)
    },
    async unmounted() {
        window.removeEventListener("scroll", this.handleScroll)
    },
}).mount('#ListingSearch');
